export enum BehaviorStatus {
    Unknown = 0,
    NotInitialized = 1,
    Initialized = 2,
    Finalized = 3
}